import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

function ShareRow({ share, setShares, setItems, item, setAlert }) {
  const [disable, setDisable] = useState(false);
  useEffect(() => {}, [share, item]);

  const shareRevoke = (shareID) => {
    if (disable) {
      return;
    }

    setDisable(true);
    // Send ajax request to revoke share
    let nonce = document.getElementById("_wpnonce").value;

    let data_val = {
      share_id: shareID,
    };
    document.body.style.cursor = "wait";

    fetch("/wp-admin/admin-ajax.php", {
      method: "POST",
      body: new URLSearchParams({
        action: "revoke_shared_content",
        data: JSON.stringify(data_val),
      }),
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "X-WP-Nonce": nonce, // here you used the wrong name
      },
    })
      .then((response) => response.json())
      // .then((response) => JSON.decode(response.body) )
      .then((data) => {
        

        document.body.style.cursor = "default";
        if (data.status == 200) {
          setAlert((old) => ({
            show: true,
            message: data.response,
            isError: false,
          }));


          // decrement item license_used
          setItems((items) => {
            let newItems = items.map((i) => {
              if (i.id === item.id) {
                i.license_used = i.license_used - 1;
                for (let sinShare in i.active) {
                  if (i.active[sinShare].id === shareID) {
                    let newActive = i.active[sinShare];

                    i.active.splice(sinShare, 1);
                    i.active.push({
                      id: newActive.id,
                      expiry: newActive.expiry,
                    });
                  }
                }
              }

              return i;
            });
            return newItems;
          });

          setShares((oldShares) => {
            let newShares = oldShares.filter((s) => s.id !== shareID);

            return newShares;
          });
        }
        else{
          setAlert((old) => ({
            show: true,
            message: data.response,
            isError: true,
          }));
        }
      })
      .catch(function (error) {
        document.body.style.cursor = "default";
        setAlert((old) => ({ ...old, show: true, message: "", isError: true }));
      });
  };

  const dateFormat = (expiry) => {
    let date = new Date(parseInt(expiry) * 1000);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const progressFormat = (progress) => {
    // Active tags for membership subscription products
    if (item.tag == "membership") {
      return "Active";
    }

    if (progress == 100) {
      return "Completed";
    } else if (progress == 0) {
      return "Not Started";
    }

    return `${progress}%`;
  };

  const progressClass = (progress) => {
    // Don't need to calculate the class for membership subscription products, these always display as "Active"
    if (item.tag == "membership") {
      return "share-single__status progress-" + 100;
    }

    if (progress == 100 || progress == 0) {
      return "share-single__status progress-" + progress;
    }
    return "share-single__status progress-started";
  };

  return (
    <Row className="share-single">
      <Col className="share-single__name">{share.share_user_email}</Col>
      {item.content_type != "e-manual" && item.tag != "membership" && item.content_type != 'e-course' && item.content_type != 'certificate-self-guided'  ? (
        <Col className="share-single__expiry">{dateFormat(share.expiry)}</Col>
      ) : (
        ""
      )}

      {item.content_type != "e-manual" ? (
        <Col className={progressClass()}>
          <div class="status--pill">{progressFormat(share.progress)}</div>
        </Col>
      ) : (
        ""
      )}
      {item.content_type != "e-manual" && item.tag != "membership" ? (
        <Col className="share-single__cert">
          {share?.pdf ? (
            <a
              href={share.pdf}
              target="_blank"
              className="share-cert share-cert--active"
            ></a>
          ) : (
            <div className="share-cert share-cert--none"></div>
          )}
        </Col>
      ) : (
        ""
      )}
      <Col className="share-single__revoke">
        <button
          onClick={() => shareRevoke(share.id)}
          className="share-single__actions__revoke"
        ></button>
      </Col>
    </Row>
  );
}

export default ShareRow;
